<template>
  <div class="bg_gray">
    <Header navTitle="我的卡包" navPath="/mobile/center"></Header>
    <van-tabs
      v-model:active="tabActiveName"
      color="#009dd9"
      title-active-color="#00ADEF"
      line-width="60"
      class="tab_common">
      <van-tab title="会员卡" name="vip_card">
        <!-- tabs -->
        <div class="container filter_list">
          <van-row gutter="10">
            <van-col span="6">
              <span :class="{ 'active': vipCardTabActiveName === 'normal' }" @click="vipCardTabActiveName = 'normal'">未过期</span>
            </van-col>
            <van-col span="6">
              <span :class="{ 'active': vipCardTabActiveName === 'expired' }" @click="vipCardTabActiveName = 'expired'">已过期</span>
            </van-col>
          </van-row>
        </div>
        <div class="container list">
          <LoadList :pager="vipUserList.pager"
                    v-model:loading="vipUserList.loading"
                    v-model:finished="vipUserList.finished"
                    @getPager="getPagerVipUser">
          <van-row :gutter="15" v-if="vipUserList.pager.total > 0">
            <van-col :span="24"  v-for="vip_card in vipUserList.data">
              <VipCard :vip_card="vip_card" :disabled="vipCardTabActiveName == 'expired'"
                       :price_visible="false" :btn_buy="false"
                       :tag_stop="!vip_card.is_enabled"
                       :expired_text_color="vip_card.expired_text_color"
                       :expired_at="vip_card.expired_at"
                       @show-detail-modal="showDetailModal('vip', vip_card)"></VipCard>
            </van-col>
          </van-row>
          <van-empty v-else description="暂无内容哦~"></van-empty>

          </LoadList>
        </div>
      </van-tab>
      <van-tab title="优惠券" name="coupons">
        <div class="container filter_list code_input">
          <!-- 兑换码 -->
          <van-form ref="couponsExchangeFrm">
            <van-field
              v-model="couponsExchangeFrm.exchangeCode"
              label="兑换码"
              label-width="60"
              placeholder="请输入优惠券兑换码"
              :rules="rules.exchangeCode">
              <template #button>
                <van-button size="small" type="primary" @click="exchangeCouponsUser">领取</van-button>
              </template>
            </van-field>
          </van-form>
          <!-- tabs -->
          <van-row gutter="10">
            <van-col span="6">
              <span :class="{ 'active': couponTabActiveName === 'received' }" @click="couponTabActiveName = 'received'">未使用</span>
            </van-col>
            <van-col span="6">
              <span :class="{ 'active': couponTabActiveName === 'ordered' }" @click="couponTabActiveName = 'ordered'">使用中</span>
            </van-col>
            <van-col span="6">
              <span :class="{ 'active': couponTabActiveName === 'used' }" @click="couponTabActiveName = 'used'">已使用</span>
            </van-col>
            <van-col span="6">
              <span :class="{ 'active': couponTabActiveName === 'expired' }" @click="couponTabActiveName = 'expired'">已过期</span>
            </van-col>
          </van-row>
        </div>
        <div class="container list">
          <LoadList :pager="couponsUserList.pager"
                    v-model:loading="couponsUserList.loading"
                    v-model:finished="couponsUserList.finished"
                    @getPager="getPagerCouponsUsers">
          <van-row :gutter="15" v-if="couponsUserList.pager.total > 0">
            <van-col :span="24"  v-for="coupons in couponsUserList.data">
              <Coupons :coupons="coupons"
                     :disabled="couponTabActiveName == 'expired'"
                     :tag_stop="!coupons.is_enabled"
                     :user_limit_visible="false" :btn_issue="false"
                     :expired_at="coupons.expired_at"
                     :expired_text_color="coupons.expired_text_color"
                     :related_order="coupons.related_order"
                     @show-related-order-detail="showRelatedOrderDetail(coupons.related_order)"
                     @show-detail-modal="showDetailModal('coupons', coupons)"></Coupons>
            </van-col>
          </van-row>

          <van-empty v-else description="暂无内容哦~"></van-empty>
          </LoadList>

        </div>
      </van-tab>
    </van-tabs>

    <!-- 详情框 -->
    <DiscountDetailModal :title="detailModal.title"
                         v-model:visible="detailModal.visible"
                         :type="detailModal.discountType"
                         :data="detailModal.data"></DiscountDetailModal>
  </div>
</template>

<script>
  import Header from 'components/mobile/common/Header'
  import { showMessage, showNotify } from 'api/base/mobile/message'
  import { getPagerOffsetLimit } from 'utils/common'
  import Pagination from 'components/common/Pagination'
  import DiscountDetailModal from "components/mobile/settlement/DiscountDetailModal"
  import LoadList from "components/mobile/common/LoadList"
  import VipCard from "components/mobile/settlement/VipCard"
  import Coupons from "components/mobile/settlement/Coupons"
  import {fmtVIPCardInfo} from 'api/settlement/vip_card/admin'
  import {listVipUser} from 'api/settlement/vip_card/user'
  import {fmtCouponsInfo} from 'api/settlement/coupons/admin'
  import {fmtOrderInfo} from 'api/settlement/order/admin'
  import {expired_delta_days_conf} from 'api/settlement/card_util'
  import {exchangeCoupons, listCouonsUser} from 'api/settlement/coupons/user'
  import { db_time_to_local_fmt } from 'utils/timeutils'
  import {getVipUserInstance, getCouponsUserInstance} from 'api/settlement/center_card'
  export default {
    components: {
      Header,
      Pagination,
      DiscountDetailModal,
      VipCard,
      Coupons,
      LoadList
    },
    data() {
      return {
        first_loading: true,
        tabActiveName: 'vip_card',
        vipCardTabActiveName: 'normal',
        couponTabActiveName: 'received',
        vipUserList: {
          loading: false,
          finished: false,
          data: [],
          pager: {
            currentPage: 0,
            pageSize: 10,
            total: 0,
          }
        },
        couponsUserList: {
          loading: false,
          finished: false,
          data: [],
          pager: {
            currentPage: 0,
            pageSize: 10,
            total: 0,
          }
        },
        detailModal: {
          visible: false,
          title: '',
          data: {
            'name': '-',
            'desc': '-',
            'discount': '-',
            'num': '-',
            'expire': '-',
            'rights': '-',
            'get': '-',
            'use': '-',
            'apply': '-'
          }
        },
        couponsExchangeFrm: {
            exchangeCode: ''
        },
        rules: {
          exchangeCode: [
            {required: true, message: '请输入优惠券兑换码', trigger: 'onChange'},
            {required: true, validator: (value, rule) =>{

              if (12 <= value.length && value.length <= 20) {
                return true;
              } else {
                return false;
              }

            }, message: '长度在 12~20 个字符内', trigger: 'onChange'},
          ],
        }
      }
    },
    created() {

      if (this.$route.params.tabName != undefined) {
        this.tabActiveName = this.$route.params.tabName;
      } else {
          this.tabActiveName = 'vip_card';
      }
    },
    mounted() {
      this.$emit('update:isShowHeader', false);
      switch(this.tabActiveName){
        case 'vip_card': {
            this.loadVipUsers();
        } break;
        case 'coupons': {
            this.loadCouponsUsers();
        } break;
      }
    },
    methods: {
      async showDetailModal(type, data) {


        const that = this;

        switch (type) {
          case 'vip': {

            let filled_vip = await getVipUserInstance(data.vip_user_uuid, ()=>{
                that.$emit('update:isShowOverlay', true);
            }, ()=>{
                that.$emit('update:isShowOverlay', false);
            });
            console.log(`filled_vip: `, filled_vip);

            data = filled_vip;

            console.log(data);

            this.detailModal.discountType = 'vip';
            this.detailModal.title = `会员卡 ${data.name} `;

            this.detailModal.data = {
              name: data.name,
              desc: data.desc.trim().length == 0 ? '-' : data.desc.trim(),
              discount: data.discount_text,
              promote_price: data.promote_price,
              origin_price: data.origin_price,
              expired_desc: data.expired_desc,
              rights_tips: data.rights_tips.trim().length == 0 ? '-' : data.rights_tips.trim(),
              receive_tips: data.receive_tips.trim().length == 0 ? '-' : data.receive_tips.trim(),
              instructions: data.instructions.trim().length == 0 ? '-' : data.instructions.trim(),
              cur_scope_detail: data.cur_scope_detail,
              cur_scope: data.cur_scope,
            }

            console.log(data);

          } break;
          case 'coupons': {

            let filled_coupons_user = await getCouponsUserInstance(data.coupons_user_uuid, ()=>{
                that.$emit('update:isShowOverlay', true);
            }, ()=>{
                that.$emit('update:isShowOverlay', false);
            });

            console.log(`filled_coupons_user: `, filled_coupons_user);

            data = filled_coupons_user;

            this.detailModal.discountType = 'coupons';
            this.detailModal.title = `优惠券 ${data.name} `;

            this.detailModal.data = {
              name: data.name,
              desc: data.desc.trim().length == 0 ? '-' : data.desc.trim(),
              discount: `${data.discount_strength}${data.discount_text},${data.discount_limit}`,
              expired_desc: data.expired_desc,
              user_limit: data.user_limit,
              rights_tips: data.rights_tips.trim().length == 0 ? '-' : data.rights_tips.trim(),
              receive_tips: data.receive_tips.trim().length == 0 ? '-' : data.receive_tips.trim(),
              instructions: data.instructions.trim().length == 0 ? '-' : data.instructions.trim(),
              cur_scope_detail: data.cur_scope_detail,
              cur_scope: data.cur_scope,
            }

          } break;
        }

        console.log(this.detailModal.data);

        this.detailModal.visible = true;
      },
      getPagerVipUser(pager) { //获取分页变化后数据
        this.loadVipUsers();
      },
      getPagerCouponsUsers(pager) { //获取分页变化后数据
        this.loadCouponsUsers();
      },
      loadVipUsers(clear_list=false){

        if (this.vipUserList.loading) {
          return false;
        }

          const that = this;

          let pager_offset_limit = getPagerOffsetLimit(this.vipUserList.pager);

          let vip_user_filters = {
              state: this.vipCardTabActiveName ,
              limit: pager_offset_limit['limit'],
              offset: pager_offset_limit['offset']
          };

          this.vipUserList.loading = true;

          if (this.first_loading) {
            this.$emit('update:isShowOverlay', true);
            this.first_loading = false;
          }

          listVipUser(vip_user_filters).then(result=>{

              if (result.succeed){

                  if (clear_list){
                      that.vipUserList.data = [];
                  }

                  result.data.forEach(item=>{

                      let filled_item = fmtVIPCardInfo(item.vip_card);
                      filled_item.vip_user_uuid = item.uuid;
                      filled_item.expired_at = db_time_to_local_fmt(item.rights_end, 'yyyy-MM-dd');
                      filled_item.is_enabled = item.is_enabled && filled_item.state_text !=='停用';

                      let delta_conf = expired_delta_days_conf(item.rights_end);
                      filled_item.expired_days = delta_conf.delta_days;
                      filled_item.expired_text = delta_conf.delta_text;
                      filled_item.expired_text_color = delta_conf.text_color;

                      that.vipUserList.data.push(filled_item);
                  });

                  that.vipUserList.pager.total = result.count;

              } else {

                switch (result.error_code) {
                  case -9999 : {
                    this.goPath(`/mobile/login/?next=/mobile/center/card`);
                  }
                    break;
                  default: {
                    showMessage(result.error_msg)
                  }
                    break;
                }

              }

              this.vipUserList.loading = false;

              this.$emit('update:isShowOverlay', false);

          }).catch(err => {

            this.vipUserList.loading = false;
            showMessage(err)
            // that.$alert(`${err}`, '提示', {
            //   confirmButtonText: '确定'
            // });

            this.$emit('update:isShowOverlay', false);
          });

      },
      loadCouponsUsers(clear_list=false){

        if (this.couponsUserList.loading){
            return false;
        }


        const that = this;

        let pager_offset_limit = getPagerOffsetLimit(this.couponsUserList.pager);

        let coupons_user_filters = {
          state: this.couponTabActiveName,
          limit: pager_offset_limit['limit'],
          offset: pager_offset_limit['offset']
        };


        this.couponsUserList.loading = true;

        if (this.first_loading) {
          this.$emit('update:isShowOverlay', true);
          this.first_loading = false;
        }

        listCouonsUser(coupons_user_filters).then(result => {

          if (result.succeed) {

            if (clear_list){
                that.couponsUserList.data = [];
            }


            result.data.forEach(item => {

              let filled_item = fmtCouponsInfo(item.coupons);
              filled_item.coupons_user_uuid = item.uuid;
              filled_item.expired_at = db_time_to_local_fmt(item.time_end, 'yyyy-MM-dd');
              filled_item.is_enabled = item.is_enabled && filled_item.state_text !=='停用';

              let delta_conf = expired_delta_days_conf(item.time_end);
              filled_item.expired_days = delta_conf.delta_days;
              filled_item.expired_text = delta_conf.delta_text;
              filled_item.expired_text_color = delta_conf.text_color;

              if (item.order_info != null){
                  filled_item.related_order = fmtOrderInfo(item.order_info);
              }

              that.couponsUserList.data.push(filled_item);
            });

            that.couponsUserList.pager.total = result.count;

          } else {

            switch (result.error_code) {
              case -9999 : {
                this.goPath(`/mobile/login/?next=/mobile/center/card`);
              }
                break;
              default: {
                showMessage(result.error_msg)
              }
                break;
            }

          }

          this.couponsUserList.loading = false;

          this.$emit('update:isShowOverlay', false);

        }).catch(err => {

          this.couponsUserList.loading = false;
          showMessage(err)
          // that.$alert(`${err}`, '提示', {
          //   confirmButtonText: '确定'
          // });

          this.$emit('update:isShowOverlay', false);
        });

      },
      showRelatedOrderDetail(order_info){

        if (order_info && order_info.uuid) {
          this.goPath('/mobile/center/order');
        }

      },
      goPath(path) {
        this.$router.push(path);
      },
      exchangeCouponsUser(){

        const that = this;

        this.$refs['couponsExchangeFrm'].validate().then(() => {


            exchangeCoupons(this.couponsExchangeFrm.exchangeCode)
              .then(result => {

                if (result.succeed) {
                  showNotify('兑换成功，优惠券已放入卡包', 'success')
                  // that.$notify({
                  //   title: '兑换成功',
                  //   message: '优惠券已放入卡包~',
                  //   type: 'success'
                  // });

                  if (that.couponTabActiveName == 'received'){
                      that.loadCouponsUsers(true);
                  } else {
                      that.couponTabActiveName = 'received';
                  }



                } else {
                  showNotify(result.error_msg, 'warning')
                  // that.$notify({
                  //   title: '提示',
                  //   message: result.error_msg,
                  //   type: 'warning'
                  // });
                }

              }).catch(err => {
                showNotify(err, 'warning')
                // that.$notify({
                //   title: '提示',
                //   message: err,
                //   type: 'warning'
                // });
            });
        }).catch(err=>{
            console.log('error submit!!');
            return false;
        });

      },
    },
    watch: {
      tabActiveName(val){
        switch(val){
          case 'vip_card': {
              this.vipUserList.pager.total = 0;
              this.loadVipUsers(true);
          } break;
          case 'coupons': {
              this.couponsUserList.pager.total = 0;
              this.loadCouponsUsers(true);
          } break;
        }
      },
      vipCardTabActiveName(val){

        this.first_loading = true;
        this.vipUserList.data = [];
        this.vipUserList.loading = false;
        this.vipUserList.finished = false;
        this.vipUserList.pager.total = 0;
        this.vipUserList.pager.currentPage = 1;
        this.loadVipUsers(true);
      },
      couponTabActiveName(val){

        this.first_loading = true;
        this.couponsUserList.data = [];
        this.couponsUserList.loading = false;
        this.couponsUserList.finished = false;
        this.couponsUserList.pager.total = 0;
        this.couponsUserList.pager.currentPage = 1;
        this.loadCouponsUsers(true);
      },
    },
  }
</script>

<style lang="scss" scoped>
  .filter_list {
    .van-col {
      span {
        display:block;
        padding:5px;
        text-align:center;
        background:#f2f2f2;
        border-radius:20px;
        &.active {
          background:#e8f7fe;
          color:#22adef;
        }
      }
    }
  }
  .container.list {
    background:none;
  }
  :deep(.code_input) {
    .van-cell {
      padding:0 0 15px 0;
      .van-field__label {
        margin-right:5px;
        padding-top:5px;
      }
      .van-field__control {
        border: 1px solid #dbdee5;
        border-radius:3px;
        padding-left:5px;
        height:32px;
      }
      &:before {
        top:5px;
      }
    }

  }
</style>
